export default __webpack_public_path__ + "static/Calibre-MediumItalic-aa285f95879aa2c2d26b228d5e422da6.woff";